module.exports = __webpack_public_path__ + "media/images/ui__arrowUp--dark-9bc424bacdbd9707b24f2847182a1c15.png";